<template functional>
  <b-badge v-if="props.count && props.count > 0" :id="data.id" :class="['counter', data.class, data.staticClass]" :style="data.style" v-bind="data.attrs" :variant="props.variant">
    <template v-if="Number(props.count) <= Number(props.maxCount)">{{ props.count }}</template>
    <template v-else>{{ props.maxCount }}+</template>
  </b-badge>
</template>

<script>
export default {
  name: 'Counter',
  props: {
    count: {
      type: [String, Number],
      default: null
    },
    maxCount: {
      type: [String, Number],
      default: 9999
    },
    variant: {
      type: String,
      default: 'primary'
    }
  }
}
</script>

<style lang="scss">
$counter-padding: $spacer * 0.25 !default;
$counter-font-size: 12px !default;
$counter-font-weight: $font-weight-bold !default;

$counter-offset-y: $counter-font-size * -0.5 !default;
$counter-offset-x: $counter-font-size * -0.5 !default;
$counter-zindex: $zindex-dropdown - 10 !default;

.counter-wrapper {
  position: relative;

  .counter {
    position: absolute;
    top: $counter-offset-y;
    right: $counter-offset-x;
    z-index: $counter-zindex;
  }
}

.counter {
  padding: $counter-padding;
  min-width: calc(1em + #{$counter-padding * 2});
  min-height: calc(1em + #{$counter-padding * 2});
  border-radius: 2em;
  font-size: $counter-font-size;
  font-weight: $counter-font-weight;
  white-space: nowrap;
}
</style>
